import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { TypeOfBusinessJson } from "../../../DynamicFormsJson/MastersJSON/typeOfBusiness";
import { getTypeOfBusiness } from "../../../Slice/typeOfBusiness.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { withRouter } from "../../../components/withRouter";
import { typeOfBusinessColumns } from "../../../tableColumns/table-columns";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
import { apiGet, apiPost } from "../../../utils/api_service";
import { noInternetMsg, statusmsg } from "../../../config/messageconstant";
class TypeOfBusinessList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {},
        };
    }


    onChangeStatus = (rowData) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            let status = "";
            if (rowData.isActive == 0) {
                status = 1;
            } else {
                status = 0;
            }
            showLoador({ loador: true });
            apiPost({
                url: endpoint.typeOfBusiness + "/update-is-active?id=" + rowData.id +
                    "&status=" + status,
            }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (success) {
                    showNotification({ msg: statusmsg });
                    window.location.reload();
                }
            });
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }

    };




    render() {
        const { typeOfBusinessList, getTypeOfBusiness } = this.props;
        const { dynamicMasterData } = this.state;
        return (
            <>
                <DynamicMainScreen
                    dynamicMasterData={dynamicMasterData}
                    formPath={TypeOfBusinessJson.formPath}
                    fieldMeta={TypeOfBusinessJson.fieldMeta}
                    screenTitle={TypeOfBusinessJson.screenTitle}
                    showPdfDownload={false}
                    showExcelDownload={false}
                    showExtension={false}
                    pdfFileName={false}
                    excelFileName={TypeOfBusinessJson.excelFileName}
                    showAddButton={TypeOfBusinessJson.showAddButton}
                    tableColumnsToFilter={TypeOfBusinessJson.tableColumnsToFilter}
                    tableColumns={typeOfBusinessColumns}
                    tableData={typeOfBusinessList?.typeOfBusiness}
                    getTableData={getTypeOfBusiness}
                    apiBaseURL={TypeOfBusinessJson.apiBaseURL}
                    baseIdColumn={TypeOfBusinessJson.baseIdColumn}
                    showDeleteIcon={true}
                    isActiveURLFalse={true}
                    isActiveURLFalseMethod={this.onChangeStatus}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    typeOfBusinessList: state.typeOfBusiness,
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getTypeOfBusiness,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(TypeOfBusinessList);
